import { defineMessages } from "react-intl";

export const orderGrantRefundMessages = defineMessages({
  windowTitleMissingId: {
    id: "CmxKIg",
    defaultMessage: "Grant refund",
    description: "window title",
  },
  windowTitle: {
    id: "/qk66u",
    defaultMessage: "Grant refund #{orderNumber}",
    description: "window title",
  },
  formSubmitted: {
    defaultMessage: "Refund for order #{orderNumber} was granted",
    description: "notification, form submitted",
    id: "qbFKVI",
  },
});
